import React from 'react';

interface UserRoleIconProps {
  size?: number;
  color?: string;
}

export const UserRoleIcon: React.FC<UserRoleIconProps> = ({ 
  size = 16, 
  color = '#6e6e6e' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 16 16"
    >
      <path 
        fill={color} 
        d="M14.035 10.5 11 7.5l3.035-3 .715.705L12.43 7.5l2.32 2.295zM11 15h-1v-2.5A2.5 2.5 0 0 0 7.5 10h-3A2.5 2.5 0 0 0 2 12.5V15H1v-2.5A3.5 3.5 0 0 1 4.5 9h3a3.5 3.5 0 0 1 3.5 3.5zM6 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m0-1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
      />
    </svg>
  );
};

